import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { getDisplayName } from '@bingads-webui-react/hoc-utils';
import { useWizardService, matchStepState, STEP_STATES } from '@bingads-webui-react/wizard';

export const withLoadingState = (WrappedComponent) => {
  const HOC = (props) => {
    const { state } = useWizardService();
    const isLoading = matchStepState(state, STEP_STATES.FETCHING) || matchStepState(state, STEP_STATES.LOADING);

    if (!isLoading) {
      return null;
    }

    return (
      <WrappedComponent
        {...props}
      />
    );
  };

  HOC.displayName = `withFetchingState(${getDisplayName(WrappedComponent)})`;

  hoistNonReactStatics(HOC, WrappedComponent);

  return HOC;
};
